import { AllDesignationResponseModel, DesignationIdReq, DesignationResponseModel } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, All } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { DesignationDTO } from './dto/designation.dto';
import { DesignationRequest } from './dto/designation.request';
import { DesignationService } from './designation.service';
import { CommonResponse } from '@gtpl/shared-models/masters';

@ApiTags('designation')
@Controller('designation')
export class DesignationController {

    constructor(
        private service: DesignationService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createDesignation')
    async createDesignation(@Body() DTO: DesignationDTO, isUpdate: boolean = false): Promise<DesignationResponseModel>{
        try{
            return await this.service.createDesignation(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(DesignationResponseModel, error);
        }
    }

    @Post('/updateDesignation')
    async updateDesignation(@Body() DTO: DesignationDTO, isUpdate: boolean = false): Promise<DesignationResponseModel>{
        try{
            return await this.service.createDesignation(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(DesignationResponseModel, error);
        }
    }

    @Post('/getAllDesignation')
    async getAllDesignations(): Promise<AllDesignationResponseModel>{
        try{
            return await this.service.getAllDesignation();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllDesignationResponseModel, error);
        }
    }

    @Post('/getAllActiveDesignation')
    async getAllActiveDesignation(): Promise<AllDesignationResponseModel>{
        try{
            return await this.service.getAllActiveDesignation();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllDesignationResponseModel, error);
        }
    }
    @Post('/getDesignationById')
    async getDesignationById(@Body() req:DesignationIdReq): Promise<CommonResponse>{
        try{
            const data = await this.service.getDesignationById(req.designationId);
             return new CommonResponse(true,111,"retrived",data)
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/activateOrDeactivateDesignation')
    async activateOrDeactivateDesignation(@Body() designationReq: DesignationRequest): Promise<DesignationResponseModel>{
        try{
            return await this.service.activateOrDeactivateDesignation(designationReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(DesignationResponseModel, error);
        }
    }
}
